import { QuickPassSavedSearchFrequency } from '../../_types/quickpass-saved-search'

const FREQUENCY_LABELS: Record<QuickPassSavedSearchFrequency, string> = {
  instant: 'Instant',
  daily: 'Daily',
  weekly: 'Weekly',
}

/**
 * Display label for a saved-search frequency. Used for the chip on each
 * dashboard summary card.
 *
 * @param {QuickPassSavedSearchFrequency} frequency
 * @returns {string}
 */
const getFrequencyLabel = (
  frequency: QuickPassSavedSearchFrequency,
): string => {
  return FREQUENCY_LABELS[frequency]
}

export { getFrequencyLabel }
